@if (type == 'pipeSeparated') {
  <div>
    @for (language of languageList; track language; let last = $last) {
      <a
        class="has-click-handler"
        [style.font-weight]="languageBridge.language == language[0] ? 'bold' : ''"
        (click)="$event.stopPropagation(); setLanguage(language[0])"
        >
        {{ language[1] }}
      </a>
      @if (!last) {
        <span> | </span>
      }
    }
  </div>
}
@if (type == 'dropdown') {
  <div>
    <mat-select
      [ngModel]="languageBridge.language"
      (ngModelChange)="setLanguage($event)"
      panelClass="auto-width"
      >
      @for (language of languageList; track language) {
        <mat-option [value]="language[0]">
          <a
            class="has-click-handler"
				[style.font-weight]="
					languageBridge.language == language[0] ? 'bold' : ''
				"
            >
            {{ language[1] }}
          </a>
        </mat-option>
      }
    </mat-select>
  </div>
}
@if (type == 'globe') {
  <div>
    <mat-icon [matMenuTriggerFor]="menu">language</mat-icon>
    <mat-menu #menu="matMenu">
      @for (language of languageList; track language) {
        <button
          mat-menu-item
          (click)="setLanguage(language[0])"
          >
          <span
				[style.font-weight]="
					languageBridge.language == language[0] ? 'bold' : ''
				"
            >
            {{ language[1] }}
          </span>
        </button>
      }
    </mat-menu>
  </div>
}
